import axios from 'axios'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { useRecoilCallback } from 'recoil'

import { StringAtom } from '../../recoil/atoms'
import { calcTime } from '../../utils/date'

const useAuth = () => {
  const navigate = useNavigate()
  const signIn = async (username: string, password: string) =>
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/1/Console/Login?email=${username}&password=${password}`)
      .then((res) => {
        Cookies.set('LoginToken', res.data.accessToken, {
          expires: calcTime(new Date(), res.data.accessTokenttl),
          secure: true,
          sameSite: 'strict',
        })
        Cookies.set('User', JSON.stringify({ username }))
      })

  const signOut = useRecoilCallback(({ reset }) => async () => {
    Cookies.remove('LoginToken')
    reset(StringAtom('user'))
    navigate('/login')
  })

  const forgotPassword = async (username: string) =>
    axios.get(`${process.env.REACT_APP_API_DOMAIN}/1/Console/ForgotPassword?email=${username}`)

  const chechCurrentAuthUser = () => {
    const accessToken = Cookies.get('LoginToken')
    return accessToken !== undefined
  }

  return { signIn, signOut, forgotPassword, chechCurrentAuthUser }
}

export default useAuth
